import 'waypoints/lib/noframework.waypoints.min.js';
import { checkMinViewport } from "./../utils/utils";

export default class Header {
  constructor(elem, APP) {
    this.elem = elem;
    this.modalTrigger = this.elem.querySelector(".js-trigger");
    this.modal = this.elem.querySelector(".js-header-modal");
    this.closeBtn = this.elem.querySelector(".js-header-modal-close");
    this.body = document.body;
    this.triggers = this.elem.querySelectorAll(".js-menu-list-trigger");
    this.panels = this.elem.querySelectorAll(".js-menu-panel");
    this.lastScrollY = window.scrollY;
    this.isMobileVP = !checkMinViewport(window.breakpoint);
    this.currentVP = this.isMobileVP;
    this.modalMenus = this.elem.querySelector(".header-modal-menus");
    this.searchTrigger = this.elem.querySelector(".js-search-trigger");
    this.searchBar = this.elem.querySelector(".js-search-row");
    this.searchInput = this.elem.querySelector("#panthoen-search");
  }

  repositionMenuPanel(index) {
    const headings = this.modalMenus.querySelectorAll('h2');
    let targetHeight = 0;

    headings.forEach((heading, i) => {
      if(i<index) {
        targetHeight += heading.offsetHeight;
      }
    })

    console.log(targetHeight);

    this.modalMenus.scrollTo({top:targetHeight, left:0,
      behavior: "smooth",});
  }

  toggleList(index) {
    const trigger = this.triggers[index];
    const panel = this.panels[index];
    const panelHeight = `${panel.querySelector(".js-menu-list").offsetHeight}px`;

    const targetState = panel.classList.toggle("expanded") ? true : false;

    // panel.classList[targetState ? "remove" : "add"]("animate-out");
    // panel.classList[targetState ? "add" : "remove"]("animate-in");
    panel.style.height = targetState ? panelHeight : 0;
    panel.setAttribute("aria-hidden", !targetState);
    trigger.setAttribute("aria-expanded", targetState);

    // temp
    this.repositionMenuPanel(index);
  }

  resetMenus() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", false);
    })

    this.panels.forEach((panel) => {
      panel.classList.remove("expanded");
      panel.style.height = 0;
      panel.setAttribute("aria-hidden", true);
    })

    const headings = this.modalMenus.querySelectorAll('h2');
    headings.forEach((heading) => {
      heading.classList.remove('is-active');
    })
  }

  setTriggerHandler() {
    this.triggers.forEach((t, i) => {
      t.addEventListener("click", () => {
        this.panels.forEach((panel, index) => {
          if (i !== index) {
            panel.style.height = 0;
            panel.classList.remove("expanded");
            panel.setAttribute("aria-hidden", true);
            this.triggers[index].setAttribute("aria-expanded", false);
          }
        })
        this.toggleList(i);
      });
    });
  }

  resizeHandler() {
    this.isMobileVP = !checkMinViewport(window.breakpoint);

    if(this.currentVP !== this.isMobileVP) {
      if(this.isMobileVP) {
        this.elem.classList.remove("collapsed");
      } else {
        this.elem.classList.remove("solid");
      }
    }

    this.currentVP = this.isMobileVP;
  }

  scrollHandler() {
    const sy = window.scrollY;

    // if (Math.abs(this.lastScrollY - sy) <= 5) {
    //   return;
    // }

    if(!this.isMobileVP) {
      if( sy < 130 ) {
        this.elem.classList.remove("collapsed");
        this.elem.classList.remove("solid");
      } else {
        if (sy > this.lastScrollY) { //down
          this.elem.classList.add("collapsed");
        } else { // up
          this.elem.classList.remove("collapsed");
          this.elem.classList.add("solid");
        }
      }
    } else {
      if( sy < 130 ) {
        this.elem.classList.remove("collapsed");
        this.elem.classList.remove("solid");
      } else {
        if (sy > this.lastScrollY) { // down
          this.elem.classList.add("solid");
        }
      }
    }

    this.lastScrollY = sy;
  }

  init() {
    this.setTriggerHandler();

    this.modalTrigger.addEventListener('click', ()=>{
      this.modal.classList.add('is-active');
      // setTimeout(()=>{
      //   this.modalMenus.classList.add('is-active');
      // }, 100);

      const headings = this.modalMenus.querySelectorAll('h2');
      headings.forEach((heading, i) => {
        setTimeout(() => {
          heading.classList.add('is-active');
        }, i * 60)
      })

      this.body.classList.add("lock");
    })

    this.closeBtn.addEventListener('click', () => {
      this.modal.classList.remove('is-active');
      this.modalMenus.classList.remove('is-active');
      this.body.classList.remove("lock");
      this.resetMenus();
    })

    this.searchTrigger.addEventListener("click", () => {
      this.searchTrigger.classList.toggle("active");
      this.searchBar.classList[
        this.searchTrigger.classList.contains("active") ? "add" : "remove"
      ]("active");
      this.searchInput.value = "";
    });

    // const waypoint = new Waypoint({
    //   element: document.getElementById('content'),
    //   offset: -100,
    //   handler: (dir) => {
    //     console.log(dir);
    //     if(dir === 'down') {
    //       this.elem.classList.add('collapsed');
    //     } else {
    //       this.elem.classList.remove('collapsed');
    //     }
    //   }
    // })

    window.addEventListener('resize', () => {
      this.resizeHandler();
    });

    window.addEventListener('scroll', () => {
      this.scrollHandler();
    });
  }
}
